import React, { useState, useRef, useEffect } from "react";
import "./AttendanceItem.css";
import Down from "../../../src/Images/down.png";

const AttendanceItem = ({ 
  record 
}) => {
  const getStatusClassName = (status) => {
    switch (status) {
      case "Present":
        return "status present";
      case "Absent":
        return "status absent";
      case "Weekly Off":
        return "status weekly-off";
      case "Holiday":
        return "status holiday";
      case "N.A.":
        return "status na";
      default:
        return "status";
    }
  };

  const [expanded, setExpanded] = useState(false);
  const dropdownRef = useRef(null);


  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    if (expanded && dropdownRef.current) {
      const dropdownRect = dropdownRef.current.getBoundingClientRect();
      const isOverflowing = dropdownRect.right > window.innerWidth;

      if (isOverflowing) {
        dropdownRef.current.style.right = "auto";
        dropdownRef.current.style.left = "auto";
        dropdownRef.current.style.transform = "translateX(-80%)";
      } else {
        dropdownRef.current.style.right = "0";
        dropdownRef.current.style.transform = "none";
      }
    }
  }, [expanded]);

  const encodeToBase64 = (data) => {
    const concatenatedData = data.join("|"); 
    const base64Encoded = btoa(concatenatedData); 
    return base64Encoded;
  };
  
    const recordValues = [
      record?.FormattedDate,
      record?.Date,
      record?.Month,
      record?.Day,
      record?.Status,
      record?.Checkin,
      record?.Checkout,
    ];
    
    const base64Param = encodeToBase64(recordValues);
  
  return (
    <>
      <div className="attendance-item">
        <div className="left-side">
          <div className="date">
            {record?.Date} {record?.Month}
            <br></br>
            {record?.Day}
          </div>
        </div>
        <div className="right-side">
          {record?.Status == 'Holiday' ? (
            <div className="holiday-status">
              {record?.Status} {record?.HolidayName}
            </div>
          ): (
          <div className={getStatusClassName(record?.Status)}>
            {record?.Status}
          </div>
          )}
          <div className="time">
            <p>
              {record?.Status == "N/A" && (
                'N.A. ➔ N.A.'
              )}
              { record?.Status == "Weekly Off" && (
                "Weekly Off"
              )}
              { record?.Status == "Holiday"&& (
                "Holiday"
              )}
              {record?.Checkin && record?.Checkout 
                ? `${record?.Checkin} ➔ ${record?.Checkout}`
                : ""}
              {record?.Status !== "N/A" && (
                <span className="time-container">
                  <img
                    src={Down}
                    alt=""
                    className={`down-image ${expanded ? "expanded" : ""}`}
                    onClick={toggleExpand}
                  />
                  {expanded && (
                    <div className="regularization-dropdown-menu" ref={dropdownRef}>
                      {/* {record?.Status == "Present" && ( */}
                        <p className="regularization-dropdown-item">
                          <a href={`/attendance-record-details/${base64Param}`}>
                            View details
                          </a>
                        </p>
                      {/* )} */}
                      {/* <hr /> */}
                        <p className="regularization-dropdown-item">
                          <a
                            href={`/mark-regularization/${record?.FormattedDate}`}
                          >
                            Apply regularisation
                          </a>
                        </p>
                    </div>
                  )}
                </span>
              )}
            </p>
          </div>
          {record?.attendanceType}

          <div className="shift">{record?.Shift}</div>
          {record?.IsSync && (
            <div
            className={`is-sync ${
              record?.IsSync == "(Synced with darwinbox)" || record?.IsSync == "(Regularization Approved)"
                ? "green"
                : record?.IsSync == "(Regularization Pending)" || record?.IsSync == "(Changes will be synced today)"
                ? "yellow"
                : record?.IsSync == "(Regularization Rejected)"
                ? "red"
                : ""
            }`}
          >
            {record?.IsSync}
          </div>          
          )}
        </div>
      </div>
      
    </>
  );
};

export default AttendanceItem;
